import {
 ChangeDetectorRef,
 Component,
 DestroyRef,
 EventEmitter,
 inject,
 OnInit,
 Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
 ActivationWay,
 SendActivationCodeRequest,
 SendActivationCodeResponse,
} from '@core/models/DTOs/authentication.dto';
import { AuthService } from '@core/services/authentication/auth.service';
import { PersianToEnglishRegexPipe } from '@shared/pipes/persianToEnglish.pipe';
import { catchError } from 'rxjs';

@Component({
 selector: 'iho-register',
 templateUrl: './register.component.html',
 styleUrls: ['./register.component.scss'],
 providers: [PersianToEnglishRegexPipe],
})
export class RegisterComponent implements OnInit {
 phoneNumber: string = '';
 @Output() phoneNumberChange = new EventEmitter();
  @Output() IdSendActivationCode = new EventEmitter<string>();

 disabledBtn: boolean = false;
 @Output() emitActivationCode = new EventEmitter();
 showLoading: boolean = false;
 destroyRef = inject(DestroyRef);
 constructor(
  public AuthService: AuthService,
  public pipe: PersianToEnglishRegexPipe,
  public cdr: ChangeDetectorRef
 ) {}

 ngOnInit() {}

 validatePhoneNumber() {
  // Define a regular expression to validate the phone number
  const phoneRegex = /^09[0-9]{9}/; // Assumes a 10-digit phone number

  if (phoneRegex.test(this.phoneNumber)) {
   this.disabledBtn = false; // Enable the button if the phone number is valid
  } else {
   this.disabledBtn = true; // Disable the button if the phone number is not valid
   this.showLoading = false;
  }
 }

 handledRegister() {
  let modelSendActivationCode: SendActivationCodeRequest = {
   Email: '',
   Mobile: this.phoneNumber,
   ActivationWay: ActivationWay.Register,
   Token: '',
  };

  if (!this.disabledBtn) {
   this.showLoading = true;

   this.AuthService.SendActivationCode(modelSendActivationCode)
    .pipe(
     catchError((err) => {
      this.showLoading = false;
      this.disabledBtn = true;
      throw 'error in source. Details: ' + err;
     })
    )
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((res: SendActivationCodeResponse) => {
      this.IdSendActivationCode.emit(res.Id);
     this.showLoading = false;

     this.emitActivationCode.emit(res);
     if (!this.disabledBtn) this.phoneNumberChange.emit(this.phoneNumber);
    });
  }
 }

 persianToEnglishRegex(value: any) {
  return this.pipe.transform(value);
 }
 handledRegex(ev: any) {
  let val = ev.currentTarget.value;
  if (val.length >= 11) {
   this.validatePhoneNumber();
  } else {
   this.disabledBtn = false;
  }
 }
}
